import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../../context/AuthContext';
import { FaCalendarCheck, FaCalendarPlus, FaClipboardList } from 'react-icons/fa';

const AttendanceNav = () => {
  const navigate   = useNavigate();
  const location   = useLocation();
  const { user }   = useAuth();
  const base       = user?.role === 'collegeadmin' ? '/collegeadmin' : '/admin';

  const tabs = [
    { label: 'Take Attendance',  path: `${base}/attendance`,      icon: <FaCalendarCheck /> },
    { label: 'Add Holidays',     path: `${base}/holidays`,         icon: <FaCalendarPlus /> },
    { label: 'Attendance List',  path: `${base}/attendance-list`,  icon: <FaClipboardList /> },
  ];

  return (
    <div className="att-nav-row">
      {tabs.map(t => (
        <button
          key={t.path}
          className={`att-nav-btn ${location.pathname === t.path ? 'att-nav-btn-active' : ''}`}
          onClick={() => navigate(t.path)}
        >
          <span className="att-nav-icon">{t.icon}</span>
          {t.label}
        </button>
      ))}
    </div>
  );
};

export default AttendanceNav;
